import mixpanel from 'mixpanel-browser'

mixpanel.init('017ee610b3746294d01c5b84c1c8c77d')

const env_check: any = process.env.NODE_ENV === 'development'

const actions = {
    identify: (id: string) => {
        if (env_check) mixpanel.identify(id)
    },
    alias: (id: string) => {
        if (env_check) mixpanel.alias(id)
    },
    track: (name: string, props: any) => {
        if (env_check) mixpanel.track(name, props)
    },
    people: {
        set: (props: any) => {
            if (env_check) mixpanel.people.set(props)
        },
    },
}

export const Mixpanel = actions
